
@if (!pdfDoc) {
  <link  [href]="printPdfCssHref" media="print" rel="stylesheet"/>
}
@if (pdfDoc) {
  <link [href]="printPdfCssHref" media="all" rel="stylesheet" (load)="onPrintCssLoaded()" (error)="onPrintCssLoaded()"/>
}
@if (pdfDoc) {
  <nav class="navbar navbar--central navbar--screen-view fixed-top" style="top: 0px;">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-policy">
        <div class="navbar-policy__breadcrumbs d-none d-lg-flex">
          <a>{{overview?.claim_event}}</a>
        </div>
        <a href="javascript:;" routerLink="/everything.policy-resources" class="navbar-policy__close icon-hover" data-tooltip="tooltip" data-placement="bottom" title="" data-original-title="Close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
        <div class="navbar-policy__nav d-lg-none">
          <div class="navbar-policy__nav-current"><strong>{{overview?.claim_event}}</strong></div>
        </div>
      </div>
    </div>
  </nav>
}
@if (!pdfDoc) {
  <nav  class="navbar navbar--central fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-sub">
        <a href="everything.policy-resources.html" class="navbar-sub__back">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
        </a>
        <div class="navbar-sub__nav text-left">
          Claim transcript
        </div>
        <div class="navbar-sub__more">
          <div class="navbar-sub__search">
            <div class="navbar-sub__search-trigger icon-hover icon-hover--alt" id="search-trigger">
              <svg class="icon">
                <use xlink:href="#search"></use>
              </svg>
            </div>
            <div class="navbar-sub__search-container" id="search-container">
              <div class="form-control__wrap has-clear">
                <input type="search" placeholder="Search" id="search-input" autocomplete="off"
                  class="form-control form-control--sm" />
                  <a href="#" id="search-clear" class="form-control__clear"><svg class="icon">
                    <use xlink:href="#close-circle-small"></use>
                  </svg></a>
                </div>
                <div class="navbar-sub__search-up" title="Prev">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-medium"></use>
                  </svg>
                </div>
                <div class="navbar-sub__search-down" title="Next">
                  <svg class="icon">
                    <use xlink:href="#dropdown-down-medium"></use>
                  </svg>
                </div>
              </div>
              <a href="javascript:;" class="navbar-sub__search-close icon-hover icon-hover--alt" id="search-close">
                <svg class="icon">
                  <use xlink:href="#close-medium"></use>
                </svg>
              </a>
            </div>
            <div class="navbar-sub__share">
              <a href="#modal-share-menu" data-toggle="modal" class="icon-hover icon-hover--alt d-lg-none">
                <svg class="icon">
                  <use xlink:href="#share"></use>
                </svg>
              </a>
              <div class="dropdown d-none d-lg-block">
                <a href="#" class="icon-hover icon-hover--alt dropdown-toggle dropdown-toggle--nocaret"
                  data-toggle="dropdown" id="shareDropdown" aria-expanded="false">
                  <svg class="icon">
                    <use xlink:href="#share"></use>
                  </svg>
                </a>
                <div class="dropdown-menu dropdown-menu-right">
                  <div class="profile-drop">
                    <div class="profile-drop__inner">
                      <ul class="profile-drop__list list-unstyled">
                        <li>
                          <a href="javascript:;" (click)="pdfDocument()">
                            <svg class="icon">
                              <use xlink:href="#download"></use>
                            </svg>
                            <span>Download</span>
                          </a>
                        </li>
                        <!-- <li>
                        <a href="#share-email-modal" data-toggle="modal" target="_blank">
                          <svg class="icon">
                            <use xlink:href="#envelope"></use>
                          </svg>
                          <span>Email</span>
                        </a>
                      </li>
                      <li>
                        <a href="https://api.whatsapp.com/send?text=share-content-here-with-link-to-pdf"
                          target="_blank">
                          <svg class="icon">
                            <use xlink:href="#whatsapp-outline"></use>
                          </svg>
                          <span>Whatsapp</span>
                        </a>
                      </li> -->
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="navbar-sub__support">
            <div class="navbar-actions__chat dropdown dropdown--persist" id="chatDropdown">
              <a href="#" role="button" id="chatTrigger" data-toggle="dropdown" title="Chat" aria-haspopup="true"
                aria-expanded="false">
                <span class="d-none d-lg-inline">Help</span>
                <svg class="icon d-lg-none">
                  <use xlink:href="#chat"></use>
                </svg>
                <svg class="icon d-none d-lg-inline-block">
                  <use xlink:href="#chat"></use>
                </svg>
              </a>
              <div class="dropdown-menu dropdown-menu--chat" aria-labelledby="chatTrigger">
                <div class="chat-info has-emergency">
                  <div class="container">
                    <div class="chat-info__avatar">
                      <img src="assets/0/avatar/happy.png" class="img-fluid" alt="" />
                    </div>
                    <div class="chat-info__content">
                      <h5>Hi 👋! How can we help?</h5>
                      <p>Start chatting with the next available agent, or if you prefer a friendly voice our
                      licensed Everything.Insure brokers are ready to assist.</p>
                      <a href="#" class="button button--primary">Start Chat</a>
                    </div>
                    <div class="chat-info__close dropdown-close">
                      <svg class="icon">
                        <use xlink:href="#close-circle-small"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="chat-info__accordion accordion accordion--sm" id="accordion-help">
                    <div class="container">
                      <div class="accordion__item">
                        <a href="#help-1" class="accordion__title collapsed" data-toggle="collapse"
                          aria-expanded="false">
                          <div class="accordion__title-text">
                            <h6>We can create a quote for you</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-down-smaller"></use>
                            </svg>
                          </div>
                        </a>
                        <div class="accordion__body collapse" id="help-1" data-parent="#accordion-help">
                          <div class="accordion__content">
                            <span class="tag tag--sm tag--free mb-10">Free Service</span>
                            <p>Simply upload a Policy Schedule from a different Insurer and we’ll use that
                              to
                            build a new quote for you!</p>
                            <p>
                              <a href="#create-quote-modal" data-toggle="modal"
                                class="button-control button-control--tight">
                                <svg class="icon icon--sm">
                                  <use xlink:href="#upload"></use>
                                  </svg><strong>Upload Schedule</strong>
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion__item">
                          <a href="#help-2" class="accordion__title collapsed" data-toggle="collapse"
                            aria-expanded="false">
                            <div class="accordion__title-text">
                              <h6>Chat to a broker</h6>
                            </div>
                            <div class="accordion__title-caret">
                              <svg class="icon">
                                <use xlink:href="#chevron-down-smaller"></use>
                              </svg>
                            </div>
                          </a>
                          <div class="accordion__body collapse" id="help-2" data-parent="#accordion-help">
                            <div class="accordion__content">
                              <p>Our licensed Everything.Insure brokers are ready to help you. Please get in
                              touch.</p>
                              <p class="chat-info__accordion-call">
                                <svg class="icon icon--sm">
                                  <use xlink:href="#phone-filled"></use>
                                </svg>
                                <strong class="font-16">011 510 1300</strong>
                                <span>or</span>
                                <a href="#request-call-modal" data-toggle="modal"><strong>Request a
                                Call</strong></a>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion__item">
                          <a href="#" class="accordion__title collapsed">
                            <div class="accordion__title-text">
                              <h6>Let us help you</h6>
                            </div>
                            <div class="accordion__title-caret">
                              <svg class="icon">
                                <use xlink:href="#chevron-right-small"></use>
                              </svg>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="chat-info__emergency">
                    <a href="https://www.everything.insure/pages/everything.login.html" target="_blank">
                      <svg class="icon">
                        <use xlink:href="#navigation-sos"></use>
                      </svg>
                      Emergency services
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="navbar-sub__close d-none d-lg-block">
              <a href="javascript:;" routerLink="/everything.policy-resources" class="icon-hover icon-hover--alt">
                <svg class="icon">
                  <use xlink:href="#close-medium"></use>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  }
  @if (!pdfDoc) {
    <div class="breadcrumbs">
      <ul class="breadcrumbs__list">
        <li><a href="javascript:void(0)" routerLink="/everything.policies-landing">Policies</a></li>
        <li><a href="javascript:void(0)" routerLink="/everything.policy-overview">Overview</a></li>
        <li><a href="javascript:void(0)" routerLink="/everything.policy-resources">Documents</a></li>
        <li>Claim transcript</li>
      </ul>
    </div>
  }
  <main class="page-main" id="main">
    <div [ngClass]="pdfDoc ? null:'layout layout--central'" [style]=" pdfDoc ? 'height: 100%;':null">
      <div [ngClass]="pdfDoc ? null:'layout__row'" [style]=" pdfDoc ? 'height: 100%;':null">
        @if (!pdfDoc) {
          <div  class="layout__sidecol" >
            <nav class="central-nav has-scrollto has-burger">
              <ul class="central-nav__list list-unstyled" id="docs-nav">
                <li>
                  <a href="#anchor-overview"><span>Overview</span></a>
                </li>
                <li>
                  <a href="#anchor-details"><span>Details</span></a>
                </li>
                @for (section of getSections(); track section) {
                  <li>
                    <a href="#anchor-{{section.replace(' ','-').toLowerCase()}}"><span>{{section}}</span></a>
                  </li>
                }
              </ul>
              <div class="central-nav__burger">
                <svg class="icon">
                  <use xlink:href="#menu"></use>
                </svg>
              </div>
            </nav>
          </div>
        }
        <div [ngClass]="pdfDoc ? null:'layout__bodycol'"  id="search-body" [style]=" pdfDoc ? 'height: 100%;':null">

          <section [ngClass]="pdfDoc ? 'pdf-page pdf-page--cover': 'pdf-view'" id="anchor-overview" data-title="Overview">
            <div class="pdf-page__component">
              <header class="pdf__coverhead">
                <div class="pdf__coverhead-logo">
                  <span><img src="{{overview?.ei_logo}}" alt="Everything.Insure"></span>
                  <span class="pdf__coverhead-tagline"><img src="{{overview?.tagline}}"
                  alt="Your only insurance platform"></span>
                </div>
                <div class="pdf__coverhead-company">
                  <img src="{{overview?.insurer_logo}}" class="img-fluid">
                </div>
              </header>


              <div class="pdf__cover-details">

                <div class="pdf__cover-details-logo">
                  <!-- personal logo -->
                  <img src="https://assets.everything.insure/{{overview?.category_id}}/logo.svg" class="img-fluid d-inline-block" alt="Personal logo">
                  <!-- <svg-icon src="https://assets.everything.insure/0/logo.svg"
                  class="img-fluid fill-{{getCSS(overview?.category)}}"
                [applyClass]="true"></svg-icon> -->
              </div>
              <h1>{{overview?.claim_event}}</h1>
              <ul class="list-unstyled">
                <li>Claim reference: <span class="font-semibold">{{overview?.claim_reference}}</span></li>
                <li>Completed by: <span class="font-semibold">{{overview?.completed_by}}</span></li>
              </ul>
            </div>


          </div>
        </section>
        @if (pdfDoc) {
          <section class="pdf-page">
            <div class="pdf-page__component">
              <header class="pdf__coverhead">
                <div class="pdf__coverhead-logo">
                  <span><img src="https://assets.everything.insure/0/logo.svg" alt="Everything.Insure"></span>
                </div>
                <div class="pdf__coverhead-title">
                  <!-- <h3>{{overview?.claim_event}}</h3> -->
                </div>
              </header>
              <div class="pdf__index">
                <ul class="list-unstyled pdf-index">
                </ul>
              </div>
            </div>
            @if (pdfDoc) {
              <footer class="pdf-page__footer">
                <div class="pdf-page__footer-inner">
                  <img [src]="footer?.footer_logo" alt="Everything.Insure">
                  <p [innerHTML]="footer?.footer_copy"></p>
                  <div>p. <span class="pdf-page-num"></span></div>
                </div>
              </footer>
            }
          </section>
        }
        <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" id="anchor-details" data-title="Details">
          <div class="pdf-page__component">
            <div class="pdf-page__component-title">
              <div class="pdf-page__component-title-text">
                <h2 class="font-serif">Details</h2>
              </div>
            </div>
            <div class="pdf__data">
              <div class="pdf__data-title">
                <h4>Event</h4>
              </div>
              <div class="pdf__data-table">
                <ul class="data data--transcript-new">
                  @for (item of getSectionItems('General'); track item) {
                    <li class="data__row">
                      @if (item?.key !== 'index' && item?.key !== 'section') {
                        <label class="data__label" [innerHTML]="item?.question_copy">
                        </label>
                        <div class="data__cell">
                          @if (!checkIfResource(item)) {
                            @if (!item?.answers) {
                              <span>{{item?.answer}}</span>
                            }
                            @if (item?.answers?.length > 0) {
                              <div class="data__cell-table">
                                @for (answer of item?.answers; track answer; let i = $index) {
                                  <div class="data__cell-table-row">
                                    <div class="data__cell-table-cell">{{answer?.answer}}</div>
                                  </div>
                                }
                              </div>
                            }
                          }
                          @if (checkIfResource(item) && pdfDoc) {
                            <div  class="d-flex align-items-center">
                              <a href="{{web}}central/claim-transcript?tid={{token_id}}" target="_blank" class="data__cell-qr">
                                <img src="https://vader.everything.insure/qr/?data={{web}}central/claim-transcript?tid={{token_id}}"  alt="" />
                              </a>
                            </div>
                          }
                          @if (checkIfResource(item) && !pdfDoc) {
                            <div class="transcript-gallery mt-4 mt-md-0">
                              @if (!item?.answers) {
                                <div class="transcript-gallery__item transcript-item" [ngClass]="isImage(media) ? '' : 'transcript-item--other'"
                                  data-toggle="modal" (click)="showMedia(item)" data-target="#guid-6cfa3bbe">
                                  @if (isImage(media)) {
                                    <img src="{{getLink(item)}}" alt="" />
                                  }
                                  @if (!isImage(media)) {
                                    <div class="transcript-item-icon">
                                      <img src="{{getLink(item)}}" class="icon" alt="">
                                    </div>
                                  }
                                  @if (!isImage(media)) {
                                    <div class="transcript-item-detail"></div>
                                  }
                                </div>
                              }
                              @if (item?.answers?.length > 0) {
                                @for (answer of item?.answers; track answer; let i = $index) {
                                  <div data-toggle="modal" (click)="showMedia(item, answer)"
                                    data-target="#guid-6cfa3bbe"
                                    class="transcript-gallery__item transcript-item">
                                    @if (!pdfDoc) {
                                      <img src="{{getLink(item)}}" alt="">
                                    }
                                    @if (pdfDoc) {
                                      <img src="assets/img/samples/qr-code-sample.png" alt="" />
                                    }
                                  </div>
                                }
                              }
                            </div>
                          }
                          @if (item?.comment) {
                            <div class="note note--transcript mt-15">
                              <div class="note__icon">
                                <svg class="icon">
                                  <use xlink:href="#note"></use>
                                </svg>
                              </div>
                              <div class="note__content">
                                <p><small [innerHTML]="item?.comment"></small></p>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
          @if (pdfDoc) {
            <footer class="pdf-page__footer">
              <div class="pdf-page__footer-inner">
                <img [src]="footer?.footer_logo" alt="Everything.Insure">
                <p [innerHTML]="footer?.footer_copy"></p>
                <div>p. <span class="pdf-page-num"></span></div>
              </div>
            </footer>
          }
        </section>
        <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" id="anchor-policy" data-title="Policy">
          <div class="pdf-page__component">
            <div class="pdf__data">
              <div class="pdf__data-title">
                <h4>Policy</h4>
              </div>
              <div class="pdf__data-table">
                <ul class="data data--transcript-new">
                  @for (item of policyDetails; track item) {
                    <li class="data__row">
                      @if (item?.key !== 'index' && item?.key !== 'section') {
                        <label class="data__label" [innerHTML]=" toTitleCase(item?.key)">
                        </label>
                        <div class="data__cell" [innerHTML]="item?.value">
                        </div>
                      }
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
          @if (pdfDoc) {
            <footer class="pdf-page__footer">
              <div class="pdf-page__footer-inner">
                <img [src]="footer?.footer_logo" alt="Everything.Insure">
                <p [innerHTML]="footer?.footer_copy"></p>
                <div>p. <span class="pdf-page-num"></span></div>
              </div>
            </footer>
          }
        </section>
        @for (class of getClasses(); track class) {
          <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" id="anchor-{{class.replace(' ','-').toLowerCase()}}" [attr.data-title]="class.replace(' ','-').toLowerCase()">
            <div class="pdf-page__component-title">
              <div class="pdf-page__component-title-text">
                <h2 class="font-serif">{{class}}</h2>
              </div>
            </div>
            @for (item of getItemsByClass(class); track item) {
              <div class="pdf-page__component">
                <div class="pdf__data">
                  <div class="pdf__data-title">
                    <h4>{{item?.sub_header}}</h4>
                  </div>
                  <div class="pdf__data-table">
                    <ul class="data data--transcript-new">
                      @for (question of getItemQuestions(item, class); track question) {
                        <li class="data__row">
                          <label class="data__label" [innerHTML]="question?.question_copy">
                          </label>
                          <div class="data__cell">
                            @if (!checkIfResource(question)) {
                              @if (!question?.answers) {
                                <span>{{question?.answer}}</span>
                              }
                              @if (question?.answers?.length > 0) {
                                <div class="data__cell-table">
                                  @for (answer of question?.answers; track answer; let i = $index) {
                                    <div class="data__cell-table-row">
                                      <div class="data__cell-table-cell">{{answer}}</div>
                                    </div>
                                  }
                                </div>
                              }
                            }
                            @if (checkIfResource(question) && pdfDoc) {
                              <div  class="d-flex align-items-center">
                                <a href="{{web}}central/claim-transcript?tid={{token_id}}" target="_blank" class="data__cell-qr">
                                  <img src="https://vader.everything.insure/qr/?data={{web}}central/claim-transcript?tid={{token_id}}"  alt="" />
                                </a>
                              </div>
                            }
                            @if (checkIfResource(question) && !pdfDoc) {
                              <div class="transcript-gallery mt-4 mt-md-0">
                                @if (!question?.answers) {
                                  <div class="transcript-gallery__item transcript-item"
                                    data-toggle="modal" (click)="showMedia(question)" data-target="#guid-6cfa3bbe">
                                    @if (!isVideo(question)) {
                                      <img src="{{getLink(question)}}" alt="" />
                                    }
                                    @if (isVideo(question)) {
                                      <img src="assets/icn/documents/audio.svg" alt="" />
                                    }
                                  </div>
                                }
                                @if (question?.answers?.length > 0) {
                                  @for (answer of question?.answers; track answer; let i = $index) {
                                    <div data-toggle="modal" (click)="showMedia(question, answer)" data-target="#guid-6cfa3bbe" [ngClass]="isVideo(answer) ? 'transcript-item--video' : ''" class="transcript-gallery__item transcript-item">
                                      @if (!isVideo(answer)) {
                                        <img src="{{answer?.answer}}" alt= "">
                                      }
                                      <!-- <img *ngIf="isVideo(answer)" src="assets/icn/documents/audio.svg" alt="" /> -->
                                      @if (isVideo(answer)) {
                                        <img src="assets/img/samples/accident-landscape-thumb.jpg" alt="">
                                        <div class="transcript-item-play">
                                          <svg class="icon">
                                            <use xlink:href="#play"></use>
                                          </svg>
                                        </div>
                                        <div class="transcript-item-time">5:23</div>
                                      }
                                      <!-- <video *ngIf="isVideo(answer)" width="80" height="80" controls>
                                      <source src="{{answer?.answer}}" type="video/mp4">
                                      Your browser does not support the video tag.
                                    </video> -->
                                  </div>
                                }
                              }
                            </div>
                          }
                          @if (question?.comment) {
                            <div class="note note--transcript mt-15">
                              <div class="note__icon">
                                <svg class="icon">
                                  <use xlink:href="#note"></use>
                                </svg>
                              </div>
                              <div class="note__content">
                                <p><small [innerHTML]="question?.comment"></small></p>
                              </div>
                            </div>
                          }
                        </div>
                      </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          }
          @if (pdfDoc) {
            <footer class="pdf-page__footer">
              <div class="pdf-page__footer-inner">
                <img [src]="footer?.footer_logo" alt="Everything.Insure">
                <p [innerHTML]="footer?.footer_copy"></p>
                <div>p. <span class="pdf-page-num"></span></div>
              </div>
            </footer>
          }
        </section>
      }

    </div>
  </div>
</div>

</main>

<div class="sidesheet sidesheet--menu" id="sidesheet">
  <div class="sidesheet__inner">

    <div class="sidesheet__body">

      <div class="has-scrollto">
        <ul class="central-nav__list list-unstyled" id="docs-nav-mobile">
          <li>
            <a href="#anchor-overview"><span>Overview</span></a>
          </li>
          <li>
            <a href="#anchor-details"><span>Details</span></a>
          </li>
          <li>
            <a href="#anchor-items"><span>Items</span></a>
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>
<div class="sidesheet__overlay"></div>
<!-- tray menu modal (mobile only) -->
<div class="modal fade modal--tray" id="modal-share-menu" tabindex="-1" role="dialog"
  aria-labelledby="modal-traymenu-more" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list list-unstyled">


          <a href="link-to-pdf.pdf" target="_blank" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#download"></use>
            </svg>
            <div>Download</div>
          </a>

          <a href="#share-email-modal" data-toggle="modal" target="_blank"
            class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#envelope"></use>
            </svg>
            <div>Email</div>
          </a>

          <a href="https://api.whatsapp.com/send?text=share-content-here-with-link-to-pdf" target="_blank"
            class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#whatsapp-outline"></use>
            </svg>
            <div>Whatsapp</div>
          </a>

        </div>

        <a href="#" data-dismiss="modal" class="modal-traymenu__close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
          <div>Close</div>
        </a>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->


<!-- alert modal (share via email) -->
<div class="modal fade modal--alert" id="share-email-modal" tabindex="-1" role="dialog"
  aria-labelledby="share-email-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/3/avatar/happy.png" class="img-fluid" alt="" />
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>Share via email</h3>
          </div>

          <div class="form-group has-action">
            <input type="email" value="" data-msg-error="Please enter a valid email address"
              placeholder="Enter email address" class="form-control" />
              <a href="javascript:;" class="form-group__append action-clear">
                <svg class="icon">
                  <use xlink:href="#trash"></use>
                </svg>
              </a>
            </div>
            <div class="form-group has-action">
              <input type="email" value="" data-msg-error="Please enter a valid email address"
                placeholder="Enter email address" class="form-control" />
                <a href="javascript:;" class="form-group__append action-clear">
                  <svg class="icon">
                    <use xlink:href="#trash"></use>
                  </svg>
                </a>
              </div>
              <div class="form-group has-action">
                <input type="email" value="" data-msg-error="Please enter a valid email address"
                  placeholder="Enter email address" class="form-control" />
                  <a href="javascript:;" class="form-group__append action-clear">
                    <svg class="icon">
                      <use xlink:href="#trash"></use>
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            <div class="modal-alert__button">
              <div class="container">
                <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
                <a href="#" disabled class="button button--lg button--primary" data-dismiss="modal"
                id="send-invites-btn">Share</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /modal -->


      <!-- alert modal (transcript gallery) -->
      <div class="modal fade modal--alert modal--transcript-gallery" id="guid-6cfa3bbe" tabindex="-1"
        role="dialog" aria-labelledby="transcript-gallery-modal" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content modal-mini">
            <div class="modal-mini__heading">
              <div class="container-fluid">
                <h4 [innerHTML]="media?.question_copy"></h4>
                <button class="modal-mini__heading-close" data-dismiss="modal">
                  <svg class="icon">
                    <use xlink:href="#close-medium"></use>
                  </svg>
                </button>
              </div>
            </div>
            <div class="modal-mini__content">
              <div class="container-fluid">
                <div class="slider slider--gallery" id="media-slider">
                  @if (!media?.answers) {
                    <div class="slider__slide">
                      <div [ngClass]="isImage(media) ? 'slider__slide-img' : 'slider__slide-other'" >
                        <img src="{{getLink(media)}}" alt="" class="icon" loading="lazy" />
                      </div>
                      @if (isVideo(media)) {
                        <div class="slider__slide-vid">
                          <video width="1600" height="900" controls>
                            <source src="{{media?.answer}}" type="video/mp4">
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      }
                      @if (media?.comment) {
                        <div class="slider__slide-note">
                          <div class="note note--transcript-dark">
                            <div class="note__icon">
                              <svg class="icon">
                                <use xlink:href="#note"></use>
                              </svg>
                            </div>
                            <div class="note__content">
                              <p><small  innerHTML="media?.comment"></small></p>
                            </div>
                          </div>
                        </div>
                      }
                      <div class="slider__slide-download">
                        <a href="{{media?.answer}}" download>
                          <svg class="icon">
                            <use xlink:href="#download"></use>
                          </svg>
                          <span>Download this image</span>
                        </a>
                      </div>
                    </div>
                  }
                  @if (selectedMedia) {
                    <div class="slider__slide">
                      @if (!isVideo(selectedMedia)) {
                        <div  class="slider__slide-img">
                          <img src="{{selectedMedia?.answer}}" alt="" loading="lazy" />
                        </div>
                      }
                      @if (isVideo(selectedMedia)) {
                        <div class="slider__slide-vid">
                          <video width="1600" height="900" controls>
                            <source src="{{selectedMedia?.answer}}" type="video/mp4">
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      }
                      @if (media?.comment) {
                        <div class="slider__slide-note">
                          <div class="note note--transcript-dark">
                            <div class="note__icon">
                              <svg class="icon">
                                <use xlink:href="#note"></use>
                              </svg>
                            </div>
                            <div class="note__content">
                              <p><small  innerHTML="media?.comment"></small></p>
                            </div>
                          </div>
                        </div>
                      }
                      <div class="slider__slide-download">
                        <a href="{{selectedMedia?.answer}}" download>
                          <svg class="icon">
                            <use xlink:href="#download"></use>
                          </svg>
                          <span>Download this image</span>
                        </a>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="modal-mini__footer">
              <div class="container-fluid">
                <div class="gallery-slider gallery-slider--scrollable" id="gallery-slider-thumbs-00">
                  <div class="gallery-slider__list">
                    @for (item of media?.answers; track item) {
                      <div class="gallery-slider__item transcript-item" [ngClass]="isVideo(item) ? 'transcript-item--video' : ''">
                        @if (!isVideo(item)) {
                          <img src="{{item?.answer}}" alt="" (click)="setMedia(item)" draggable="false" />
                        }
                        @if (isVideo(item)) {
                          <img src="assets/img/samples/accident-landscape-thumb.jpg" (click)="setMedia(item)" alt="">
                          <div class="transcript-item-play">
                            <svg class="icon">
                              <use xlink:href="#play"></use>
                            </svg>
                          </div>
                          <div class="transcript-item-time">5:23</div>
                        }
                      </div>
                    }

                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
      <!-- /modal -->

      <!-- pdf preview modal -->
      <div class="modal fade modal--fullscreen" id="modal-pdf-preview" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-policy-feed__heading">
              <div class="container">
                <h6>PDF Preview</h6>
                <a href="javascript:;" class="modal-policy-feed__close" data-dismiss="modal">
                  <svg class="icon"><use xlink:href="#close-medium"></use></svg>
                </a>
              </div>
            </div>
            <div class="modal-body p-0" style="height: calc(100% - 56px);">
              @if (previewFileUrl) {
                <iframe [src]="previewFileUrl" width="100%" height="100%" frameborder="0" (load)="onPdfIframeLoad()"></iframe>
              }
            </div>
          </div>
        </div>
      </div>

<!-- pdf preview modal -->
<div class="modal fade modal--fullscreen" id="modal-pdf-preview" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-policy-feed__heading">
        <div class="container">
          <h6>PDF Preview</h6>
          <a href="javascript:;" class="modal-policy-feed__close" data-dismiss="modal">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </a>
        </div>
      </div>
      <div class="modal-body p-0" style="height: calc(100% - 56px);">
        <iframe *ngIf="previewFileUrl" [src]="previewFileUrl" width="100%" height="100%" frameborder="0" (load)="onPdfIframeLoad()"></iframe>
      </div>
    </div>
  </div>
</div>

